import React, { Component } from 'react';
import { Main, Heading, SubHeading } from '../../styles/style';
import { withRouter } from 'react-router-dom';

class RegisterSuccess extends Component {

	render() {
		const email = this.props.location.state.detail;
    return (
      <Main>
        <SubHeading>One More Step…</SubHeading>
        <p style={{fontSize: '19px'}}>Thank you! We sent an email to {email} with a button to activate your account.</p>
				<p style={{fontSize: '19px'}}>
          Click that button to continue your registration. 
          If you don’t see the email, please check your junk mailbox. 
          If the email does not arrive within a half hour, contact us at <a href="mailto:hosts@onthetablebc.com?subject=Registration%20Problem">hosts@onthetablebc.com</a> and we will help you out.</p>
      </Main>
    )
  }
}

export default withRouter(RegisterSuccess)
